export const getDayName = (date) => {
  return new Date(date).toLocaleDateString("en-US", { weekday: "long" });
};

export const formatAmount = (amount) => {
  return "₹" + amount;
};
